var map = {
	"./act.svg": "6450",
	"./denglong.svg": "5d6f",
	"./more.svg": "3dd0",
	"./point.svg": "61c5",
	"./read.svg": "ce29",
	"./set.svg": "9873",
	"./user.svg": "b3b5",
	"./标签.svg": "8adb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";